import { Building2, Users, DollarSign, TrendingUp } from "lucide-react";
import { AnimatedCounter } from "./AnimatedCounter";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useTranslation } from "react-i18next";

export function StatsSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  const stats = [
    {
      icon: Users,
      end: 2500,
      suffix: "+",
      label: t("landing.stats.landlords"),
    },
    {
      icon: Building2,
      end: 10000,
      suffix: "+",
      label: t("landing.stats.properties"),
    },
    {
      icon: DollarSign,
      end: 2,
      suffix: "M+",
      prefix: "€",
      label: t("landing.stats.tracked"),
    },
    {
      icon: TrendingUp,
      end: 98,
      suffix: "%",
      label: t("landing.stats.satisfaction"),
    },
  ];

  return (
    <section ref={ref} className="py-16 bg-gradient-to-b from-background via-secondary/20 to-background">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`text-center transition-all duration-700 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
                <stat.icon className="w-8 h-8 text-primary" />
              </div>
              <div className="text-4xl font-bold text-foreground mb-2">
                <AnimatedCounter end={stat.end} suffix={stat.suffix} prefix={stat.prefix} />
              </div>
              <p className="text-muted-foreground">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
